// extracted by mini-css-extract-plugin
module.exports = {"error":"_651b5ae","submitButton":"_112adc0"};